export default __webpack_public_path__ + "7ab6118dc38f65756f6d57d7118a8bec.png";